import { t } from 'i18next';
import { confirm } from './confirm-action';
import type { CvImportReviewRequired } from './cv-import-review';

export function cvImportSectionLabels(sections: string[]) {
  return sections.map((section) => t(`cv.importEvidence.sections.${section}`, { ns: 'seeker', defaultValue: section })).join(', ');
}

export function promptCvImportReview(required: CvImportReviewRequired) {
  const message = [
    t('cv.importEvidence.reviewBody', { ns: 'seeker' }),
    required.missingSections.length ? t('cv.importEvidence.missing', { ns: 'seeker', sections: cvImportSectionLabels(required.missingSections) }) : '',
    required.clearedSections.length ? t('cv.importEvidence.cleared', { ns: 'seeker', sections: cvImportSectionLabels(required.clearedSections) }) : '',
    required.quality?.fallbackUsed ? t('cv.importEvidence.fallback', { ns: 'seeker' }) : '',
    t('cv.importEvidence.datePrecision', { ns: 'seeker' }),
  ].filter(Boolean).join('\n\n');
  return confirm({
    title: t('cv.importEvidence.reviewTitle', { ns: 'seeker' }),
    message,
    confirmLabel: t('cv.importEvidence.confirm', { ns: 'seeker' }),
    cancelLabel: t('actions.cancel', { ns: 'common' }),
    destructive: true,
  });
}
